<div class="notification-panel">
  <h3>Notifications</h3>

  <nz-divider class="notification-divider"></nz-divider>

  <div class="notification-spinner" *ngIf="isLoading">
    <nz-spin nzSimple></nz-spin>
  </div>

  <ng-container *ngIf="!isLoading">
    <nz-collapse nzAccordion>
      <nz-collapse-panel
        *ngFor="let notification of visibleNotifications; trackBy: trackNotification"
        [nzShowArrow]="false"
        [nzActive]="notification.expanded"
        (nzActiveChange)="toggleNotification(notification, $event)"
        [nzHeader]="notificationHeader"
        class="notification-collapse-panel"
      >
        <ng-template #notificationHeader>
          <div class="notification-row">
            <div class="notification-content">
              <span
                nz-icon
                class="icon-box"
                *ngIf="notification.queryType === 'WORKBENCH'"
                nzType="clock-circle"
                nzTheme="outline"
              ></span>

              <span
                nz-icon
                class="icon-box"
                *ngIf="notification.queryType === 'SCHEDULER' || notification.queryType === 'SEGMENT'"
                nzType="schedule"
                nzTheme="outline"
              ></span>

              <span class="notification-subtitle">
                Query <b>{{ notification.name }}</b>

                {{ notification.executionStatus === 'FAIL' ? 'failed to execute' : 'executed on' }}

                <b>{{ notification.executedAt | dateTime }}</b>
              </span>
            </div>

            <div class="notification-actions">
              <span
                nz-icon
                [nzType]="notification.expanded ? 'up' : 'down'"
                nzTheme="outline"
                class="user-profile-down-icon"
              ></span>

              <button
                type="button"
                class="notification-close-button"
                aria-label="Delete notification"
                (click)="deleteNotification($event, notification)"
              >
                <span nz-icon nzType="close" nzTheme="outline" class="close-icon"></span>
              </button>
            </div>
          </div>
        </ng-template>

        <!-- Only create the details content when the panel is expanded -->
        <div *ngIf="notification.expanded" class="notification-details" (click)="updateNotification(notification)">
          <ng-container *ngIf="notification.executionStatus === 'FAIL'; else successMessage">
            Reason for failure:
            <b>{{ notification.executionFailureReason }}</b>
          </ng-container>

          <ng-template #successMessage>
            Query executed successfully for:
            <b>{{ notification.name }}</b>
          </ng-template>
        </div>
      </nz-collapse-panel>
    </nz-collapse>

    <div class="notification-load-more" *ngIf="hasMoreNotifications">
      <button nz-button nzType="primary" nz-outline type="button" (click)="loadMore()">
        Load more
        <span>({{ remainingNotificationCount }} remaining)</span>
      </button>
    </div>

    <nz-empty *ngIf="visibleNotifications.length === 0" nzNotFoundContent="No notifications"></nz-empty>
  </ng-container>
</div>
